/**  Home.js  **/
 
//  First list
const offerItems = [
  "Branding",
  "Websites & applications",
  "Design",
  "Maintenance",
];
//  Second list
const perksItems = [
  "Quality",
  "Affordability",
  "Flexibility",
];
//  Services
const offer = [
  "Branding design",
  "Web design",
  "Web development",
  "E-commerce",
  "Maintenance",
  "SEO",
  "Social media",
  "Google Adwords and Analytics",
  "Amazon Web Services",
];
//  Prices for services
const prices = [
  {
    service: "Bespoke website",
    descr: "Perfect opportunity for you to either update an existing website or launch a new product.",
    points: [
      "Website and website design",
      "Maintenance and minor changes",
    ],
    price: "From £449"
  },
  {
    service: "E-commerce websites",
    descr: "Online shop made just for you. Sell goods, accept different payment methods and automate your sales.",
    points: [
      "Website and website design",
      "Administration console",
      "Maintenance and minor changes",
    ],
    price: "From £1199"
  },
  {
    service: "Branding",
    descr: "Designs and prints to order.",
    points: [
      "Logo design",
      "Business cards",
      "Web design",
      "Accessories",
      "Product design",
      "Others",
    ],
    price: "From £249"
  },
  {
    service: "Edits",
    descr: "You need a to make changes to a website or tacke a feature that does not work?",
    points: [
      "Website / application fixes",
      "Hosting migrations",
      "Changes and maintenance for the outside projects",
      "Others",
    ],
    price: "Contact us for a free quote"
  },
  {
    service: "Social media management",
    descr: "We can take care of your chosen social media accounts. How you manage the accounts can impact how much attention you will get, that momentum could push your business further.",
    points: [
      "Consistent look throughout your profiles",
      "New content on regular basis",
      "Social media campaigns",
    ],
    price: "From £49 / month"
  },
];
//  Team members
const team = [
  {
    image: "./images/Maciek.jpg",
    name: "Maciej Jarmula",
    titles: [
      "Software developer",
      "UI/UX designer"
    ],
    paragraphs: [
      "Maciej is a versatile, programmer who can work with plain JavaScript or libraries and frameworks made for it. He is familiar with Wordpress and Squarespace like page builders and has a good knowledge of Adobe Suite, with main focus on Photoshop and XD.",
      "His favourite tool to work with is React - a JavaScript library for building user interfaces which was created and is maintained by Facebook and a community of individual developers and companies."
    ],
    aboutMe: [
      "My name is Maciej, I am a software developer who works with JavaScript programming language, by combining it with my knowledge of HTML and CSS I can create impressive websites and web applications to suite all your needs.",
      "I am comfortable working with Wordpress / Squarespace and similar page builders, but custom written projects are what I thrive on and React is my best friend to help me create final products. As for hosting, I have experience using AWS S3, CloudFront, Route53, 123-reg and others.",
      "If you need to start from the scratch, that is not a problem either. I can work with Adobe Photoshop and Adobe XD to create designs which will be practical and will contribute to your brand.",
      "Using Google's My Business and Ads and combining it with social media campaigns I am capable of running your digital advertising to reach the maximum audience. As much as advertising Search Engine Optimisation also plays a big role in finding customers online, I can achive set goals in SEO as well as in any other previously mentioned field."
    ],
    moreInfo: '/maciekjarmula',
    products: [
      {
        name: 'Responsive',
        descr: 'All of my products will look great on any device, regardless of their size and resolution.',
        icon: './images/responsivnessIcon.jpg'
      },
      {
        name: 'Fast',
        descr: 'Fast load times and no lag while using the product is a top priority for me.',
        icon: './images/speedIcon.jpg'
      },
      {
        name: 'Intuitive',
        descr: 'Ease of use is another thing which I keep in my mind when developing every single product.',
        icon: './images/ideaIcon.jpg'
      },
    ],
    skills: [
      { HTML: 100 },
      { CSS: 100 },
      { JavaScript: 85 },
      { React: 80 },
      { Node: 50 },
      { Gatsby: 65 },
      { Meteor: 70 },
      { Mongo: 90 },
      { Photoshop: 75 },
      { XD: 65 },
      { SEO: 60 },
      { PHP: 45 },
      { Python: 45 }
    ]
  },
  {
    image: "./images/Sarah.jpg",
    name: "Sarah Kadrnka",
    titles: [
      "Designer",
      "Illustrator"
    ],
    paragraphs: [
      "Sarah is a graduate in Illustration with BA honours. She is a multidisciplinary artist, using both traditional and digital techniques and a wide variety of mediums. Described by others as possessing a “fertile imagination”, Sarah is very inventive person. She enjoys taking initiative and has a novel way of finding solutions.",
      "Inspired to pursue art from a young age Sarah believes creativity in all it's eccentricities brings more purpose and fulfilment to life. She loves experimenting with new techniques and will never stop to do so."
    ]
  }
];
/**  Portfolio.js  **/

//  List of projects
const partners = [
  {
    name: "BND Partner",
    service: "Wordpress website",
    link: "http://www.bondpartner.co.uk"
  },
  {
    name: "BNDCO.",
    service: "Wordpress website",
    link: "http://www.bndco.co.uk"
  },
  {
    name: "Sarah Kadrnka",
    service: "Wordpress website",
    link: "https://sarah-kadrnka.com/"
  },
  {
    name: "Stanford Hounds",
    service: "Logo design",
    link: null
  },
];
/**  Contact.js  **/

//  Opening times
const openingTimes = [
  {
    day: "Monday",
    open: "09:00",
    close: "16:30"
  },
  {
    day: "Tuesday",
    open: "09:00",
    close: "16:30"
  },
  {
    day: "Wednesday",
    open: "09:00",
    close: "16:30"
  },
  {
    day: "Thursday",
    open: "09:00",
    close: "16:30"
  },
  {
    day: "Friday",
    open: "09:00",
    close: "16:30"
  },
  {
    day: "Saturday",
    open: null,
    close: null
  },
  {
    day: "Sunday",
    open: null,
    close: null
  }
];
//    Exports
export {
  offer,
  offerItems,
  perksItems,
  team,
  prices,
  partners,
  openingTimes
};